<template>
    <div class="relative border border-gray-400 rounded-xl h-82 w-100 bg-white">
        <div class="absolute -top-10 left-40 p-3.5 h-20 w-20 mx-auto bg-primary-800 rounded-full">
            <Icon class="w-full h-full" :src="IconSource.Login"></Icon>
        </div>

        <div class="flex h-full w-full px-4">
            <form class="pt-20 pb-4 w-full flex flex-col" @submit.prevent="onSubmit">
                <div>
                    <CustomInput
                        v-model:value="form.password"
                        hide-auth-state
                        :show-required-indication="false"
                        :label="$t('views.auth.resetPassword.passwordFieldLabel')"
                        auto-complete="new-password"
                        input-type="password"
                        @submit="onSubmit"
                    ></CustomInput>
                    <CustomInput
                        v-model:value="form.confirm_password"
                        hide-auth-state
                        :show-required-indication="false"
                        :label="$t('views.auth.resetPassword.confirmPasswordFieldLabel')"
                        input-type="password"
                        auto-complete="new-password"
                        @submit="onSubmit"
                    ></CustomInput>
                </div>

                <div class="mt-auto w-full">
                    <CustomButton :disabled="disableButtons" @click="onSubmit">
                        {{ $t('views.auth.resetPassword.submitButtonLabel') }}
                    </CustomButton>
                </div>
            </form>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Form } from '@makeabledk/vue-ui/support/http';
import CustomInput from '@/components/ui/CustomInput.vue';
import CustomButton from '@/components/ui/CustomButton.vue';

export default defineComponent({
    components: { CustomInput, CustomButton },
    data() {
        return {
            form: new Form({
                password: '',
                confirm_password: '',
            }),
            disableButtons: false,
        };
    },
    methods: {
        async onSubmit() {
            this.disableButtons = true;
            alert('Not yet implemented');
            this.disableButtons = false;
            // TODO: Re-enable this once we have an endpoint
            // const resetPasswordResponse = await store.dispatch(ActionType.ResetPassword, { form: this.form });
        },
    },
});
</script>
